import { Component, OnInit, inject } from '@angular/core';
import { ReportingService } from '../../reporting.service';
import {
  ExcelModule,
  GridModule,
  GridComponent,
} from '@progress/kendo-angular-grid';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { Unit } from '../../../models/admin-models';
import { distinctUntilChanged, catchError, debounceTime } from 'rxjs/operators';
import { AdminService } from '../../../admin/admin.service';
import { MatInputModule } from '@angular/material/input';
import { saveAs } from '@progress/kendo-file-saver';
import { throwError } from 'rxjs';
import { NgxLoadingModule } from 'ngx-loading';
import { WarnDialogComponent } from '../../../warn-dialog/warn-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-unit-session-activity',
  imports: [
    GridModule,
    ExcelModule,
    MatButtonModule,
    MatIconModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatInputModule,
    NgxLoadingModule,
  ],
  templateUrl: './unit-session-activity.component.html',
  styleUrl: './unit-session-activity.component.scss',
})
export class UnitSessionActivityComponent implements OnInit {
  private rptSvc = inject(ReportingService);
  private admnSrvc = inject(AdminService);
  private dialog = inject(MatDialog);

  startDate;
  endDate;
  unitSessionActivity: any;
  activityCode: string;
  filteredUnits;
  unitsControl = new FormControl();
  units: Unit[] = [] as Unit[];
  selectedUnit;
  loading: boolean;

  ngOnInit(): void {
    this.getUnits();
    // this.getSessionActivity();
  }

  checkSelection() {
    if (
      !this.filteredUnits ||
      !this.filteredUnits.find(unit => {
        return unit.id === this.unitsControl.value;
      })
    ) {
      this.unitsControl.setValue(null);
    }
  }

  getUnits() {
    this.unitsControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(value => {
        if (value) {
          this.admnSrvc.getUnitList(value, true).subscribe(resp => {
            if (resp['names']) {
              this.filteredUnits = resp['names'];
            }
          });
        }
      });
  }

  getSessionActivity() {
    let dialogRef = this.dialog.open(WarnDialogComponent, {
      panelClass: 'warn-dialog',
      data: {
        headline: 'Disclosure',
        aiDisclosure: true,
        confirm: 'Agree and Download',
        cancel: 'Cancel/Exit',
        hideCancel: false,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'continue') {
        this.loading = true;
        const start = new Date(this.startDate).toISOString();
        const end = new Date(this.endDate).toISOString();
        const activityCode = this.activityCode || 'ALL';
        this.rptSvc
          .getUnitSessionActivity(start, end, activityCode, this.selectedUnit)
          .subscribe({
            next: res => {
              this.loading = false;
              let fileData;
              const filename = `Unit_Session_Activity-${new Date(this.startDate)
                .toDateString()
                .replaceAll(' ', '_')}-${new Date(this.endDate)
                .toDateString()
                .replaceAll(' ', '_')}.csv`;
              const reader = new FileReader();
              reader.readAsDataURL(res);

              reader.onloadend = () => {
                fileData = reader.result;
                saveAs(fileData, filename);
              };
            },
            error: catchError(err => {
              this.loading = false;
              return throwError(() => err.error || 'Server error');
            }),
          });
      }
      dialogRef = null;
    });
  }

  exportToExcel(grid: GridComponent): void {
    grid.saveAsExcel();
  }
}
